import { isBrowser } from './device-type';
// Note that this is only set in the browser, it's undefined
// when running on the server so we cannot rely on it always being
// set
let store;
export function setStoreForCrossWindowEvents(s) {
    store = s;
}
let broadcastChannel = null;
if (isBrowser() && window.BroadcastChannel) {
    broadcastChannel = new BroadcastChannel('cross-window-events');
}
const listeners = {};
if (isBrowser() && broadcastChannel) {
    let pendingCallbacks = [];
    let timer;
    const runCallbacksIfVisible = () => {
        if (document.visibilityState === 'visible' && pendingCallbacks.length) {
            console.debug('Calling cross window event callbacks because the page is visible');
            pendingCallbacks.forEach(c => c.event(store, c.data));
            pendingCallbacks = [];
        }
        else if (pendingCallbacks.length) {
            console.debug('Deferring calling cross window event callbacks because the page is not visible');
        }
    };
    broadcastChannel.onmessage = (e) => {
        const eventName = e.data.name;
        if (eventName in listeners) {
            listeners[eventName].forEach(listener => {
                if (e.data.runImmediately) {
                    listener(store, e.data.data);
                }
                else {
                    if (pendingCallbacks.map(s => s.event).indexOf(listener) === -1) {
                        pendingCallbacks.push({
                            event: listener,
                            data: e.data.data,
                            name: eventName,
                        });
                    }
                    clearTimeout(timer);
                    timer = setTimeout(runCallbacksIfVisible, 100);
                }
            });
        }
    };
    document.addEventListener('visibilitychange', runCallbacksIfVisible);
}
export function onCrossWindow(event, callback) {
    if (!isBrowser()) {
        return () => { };
    }
    const eventsArray = typeof event === 'string' ? [event] : event;
    eventsArray.forEach(eventName => {
        if (!(eventName in listeners)) {
            listeners[eventName] = [];
        }
        listeners[eventName].push(callback);
    });
    return () => {
        eventsArray.forEach(eventName => {
            const index = listeners[eventName].indexOf(callback);
            if (index !== -1) {
                listeners[eventName].splice(index, 1);
            }
        });
    };
}
export function emitCrossWindow(event) {
    return emitCrossWindowWithData({ name: event, data: null, runImmediately: false });
}
export function emitCrossWindowWithData(event) {
    if (!isBrowser()) {
        return;
    }
    if (!store) {
        throw new Error('Cannot emit cross window event before setting the Redux store');
    }
    if (broadcastChannel) {
        broadcastChannel.postMessage({
            name: event.name,
            data: event.data,
            runImmediately: event.runImmediately,
        });
    }
    else {
        console.debug('BroadcastChannel not available, not emitting cross window event');
    }
}
